import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { WarningModal } from './WarningModal.tsx';

export const i18n: {
	payloadTooLargeModalTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	payloadTooLargeModalBody: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	payloadTooLargeModalTitle: {
		id: 'import-from-sources.warning-modal.payloadTooLargeModalTitle',
		defaultMessage: 'The content is too long',
		description: 'Message in modal header indicating that content is too large',
	},
	payloadTooLargeModalBody: {
		id: 'import-from-sources.warning-modal.payloadTooLargeModalBody',
		defaultMessage: 'You can split the content into smaller files and import them separately.',
		description: 'Message in modal body indicating the steps how to overcome that issue',
	},
});

export const PayloadTooLargeModal: React.FC<{
	onSubmit: () => void;
	onClose: () => void;
}> = ({ onSubmit, onClose }) => {
	return (
		<WarningModal
			onSubmit={onSubmit}
			onClose={onClose}
			headText={<FormattedMessage {...i18n.payloadTooLargeModalTitle} />}
			bodyText={<FormattedMessage {...i18n.payloadTooLargeModalBody} />}
		/>
	);
};
